export function SET_POSITION(state, position) {
  state.position = position
}
export function SET_PERMISSION(state, permission) {
  state.permission = permission
}
